export default {
    required: '{field} is required | {field} are required',
    'not-a-number': '{field} is not a number',
    'less-than-zero': '{field} have to be greater than zero',
    'invalid-expression': 'Invalid expression',
    'list-view-components-type': 'All Component types are required',
}
